import { Color } from '@tmh-website/shared/colors';
import styled from 'styled-components';

export const Label = styled.span`
  font-weight: ${props => props.theme.fontWeight.medium};

  span {
    margin-left: 8px;
    opacity: ${({ theme }) => theme.textOpacity};
  }
`;

export const Entry = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  ${props => props.$isSelected && `color: ${props.theme.color[Color.Blue_500_Ultramarine]};`}

  svg {
    margin-right: 10px;
    overflow: hidden;
    border-radius: ${({ theme }) => (theme.isBorderRadiusDisabled ? 0 : '2px')};
    box-shadow: 0 1px 2px 0 #1018280f, 0 1px 3px 0 #1018281a;
  }
`;
